module.exports = __webpack_public_path__ + "static/media/web.fc5540c1.png";